import React from "react";

import { useIntl } from "react-intl";

import { Button, Popconfirm } from "@mapmycustomers/ui";

interface Props {
  isErrored: boolean;
  onClick: () => void;
}

const DeleteButton: React.FC<Props> = ({ isErrored, onClick }) => {
  const intl = useIntl();
  return (
    <Popconfirm
      cancelText={intl.formatMessage({
        id: "settings.sandboxEnvironment.state.deleteSandbox.confirm.cancel",
        defaultMessage: "Not yet",
        description: "Settings Sandbox Environment - state - delete confirm cancel text",
      })}
      description={intl.formatMessage({
        id: "settings.sandboxEnvironment.state.deleteSandbox.confirm.text",
        defaultMessage: "Are you sure you want to delete this sandbox configuration?",
        description: "Settings Sandbox Environment - state - delete confirm text",
      })}
      okText={intl.formatMessage({
        id: "settings.sandboxEnvironment.state.deleteSandbox.confirm.ok",
        defaultMessage: "Delete",
        description: "Settings Sandbox Environment - state - delete confirm ok text",
      })}
      onConfirm={onClick}
      placement="bottom"
    >
      <Button size="small">
        {isErrored
          ? intl.formatMessage({
              id: "settings.sandboxEnvironment.state.deleteSandbox.error",
              defaultMessage: "Delete to re-configure",
              description: "Settings Sandbox Environment - state - delete",
            })
          : intl.formatMessage({
              id: "settings.sandboxEnvironment.state.deleteSandbox",
              defaultMessage: "Delete",
              description: "Settings Sandbox Environment - state - delete",
            })}
      </Button>
    </Popconfirm>
  );
};

export default DeleteButton;
